import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { getPersonnelAdjustmentById } from 'apis/personnelAdjustment.api';

const useGetPersonnelAdjustmentById = (id, conds = {}) => {
  const { data: personnelAdjustmentData, ...rest } = useQuery(
    ['personnelAdjustmentById', id],
    () => getPersonnelAdjustmentById(id),
    {
      ...conds,
    }
  );

  const personnelAdjustment = useMemo(
    () => personnelAdjustmentData?.data ?? [],
    [personnelAdjustmentData]
  );

  return {
    data: personnelAdjustment,
    ...rest,
  };
};

export default useGetPersonnelAdjustmentById;
